module.exports = __webpack_public_path__ + "static/img/237_TO8_1995.c49eba6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/237_TO8_1995.jpg
// module id = oeCk
// module chunks = 0